import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../../global/commonStyle';

export const Content = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  ${mobile_xl(css`
    margin-top: var(--space-8);
  `)}
`;

export const Data = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
  padding: var(--space-12) var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const LeftSection = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

export const ActiveTag = styled.div`
  border: 1px solid var(--brand-secondary);
  background: var(--brand-secondary);
  border-radius: var(--border-radius-6);
  padding: var(--space-2) var(--space-4);
  color: var(--brand-primary);
  ${Typography.body_sm}
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-8);
`;

export const Title = styled.h3`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

export const Description = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

export const Heading = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  padding-block: var(--space-1);
`;

export const HeadingTitle = styled.p`
  ${Typography.body_lg_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
  padding: var(--space-2) var(--space-4);
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;

export const UserDetails = styled.div`
  ${FlexBetween}
  gap: var(--space-20);
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
  `)}
`;

export const UserSubDetails = styled.div`
  display: flex;
  gap: var(--space-12);
  img {
    padding-top: var(--space-1);
  }
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  h1 {
    ${Typography.heading_lg}
    color: var(--text-primary);
    margin: var(--space-0);
  }
`;

export const AIAgentsDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  background: var(--background-primary);
`;

export const Box = styled.div`
  padding: var(--space-12) var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
  h2 {
    ${Typography.body_lg_semibold}
    color: var(--text-primary);
    margin: var(--space-0) var(--space-0) var(--space-6);
  }
  h3 {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin-block: var(--space-8) var(--space-6);
    &:first-of-type {
      margin-top: var(--space-0);
    }
  }
  p {
    ${Typography.body_md}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: var(--space-6);
    margin: var(--space-0);
    padding-left: var(--space-16);
    li {
      ${Typography.body_md}
      color: var(--text-secondary);
      margin: var(--space-0);
    }
  }
`;

export const TagDiv = styled.div`
  .deactivate-button {
    display: none;
  }
  &:hover {
    .active-tag {
      display: none;
    }
    .deactivate-button {
      display: flex;
    }
  }
`;
